// this is aliased in webpack config based on server/client build
// server和client的要分别注意对登录态的处理
// import { createAPI } from 'create-api'

// const api = createAPI({
//   version: '',
//   config: {}
// })
// const logRequests = !!process.env.DEBUG_API
// 异步请求, 应返回Promise
// function fetch (child) {
//   logRequests && console.log(`fetching ${child}...`)
//   const cache = api.cachedItems
//   if (cache && cache.has(child)) {
//     logRequests && console.log(`cache hit for ${child}.`)
//     return Promise.resolve(cache.get(child))
//   } else {
//     return new Promise((resolve, reject) => {
//       api.child(child).once('value', snapshot => {
//         const val = snapshot.val()
//         // mark the timestamp when this item is cached
//         if (val) val.__lastUpdated = Date.now()
//         cache && cache.set(child, val)
//         logRequests && console.log(`fetched ${child}.`)
//         resolve(val)
//       }, reject)
//     })
//   }
// }

import axios from 'axios';
import * as rootUrl from './urlConfig';

const requestConfig = require('../../bin/config');
const apiDomain = process.env.VUE_ENV === 'server' ? requestConfig.apiDomain : '';

export function fetchArticleBody (articleId) {
    let id = articleId.match(/^\d+/g);
    return axios.get(`${apiDomain}/m/v2/article/body/${id ? id[0] : ''}?plat=m`).then((response) => {
        return response.data;
    }).catch(function (error) {
        return (error);
    });
}

export function fetchOddsChange (options) {
    console.log('options', options);
    const url = `${apiDomain}/data/odds/detail/${options.id}?companyId=${options.companyId}&type=${options.type}&rate=${options.rate}`;
    // const url = 'http://beta-api.allfootballapp.com/data/odds/detail/50956312?companyId=1183&type=euro&rate=Decimal';
    return axios.get(url).then(response => {
        console.log('response.data', response.data);
        return response.data;
    }).catch(function (error) {
        return (error);
    });
}

// 初始化
export const appInitApi = {
    // 新闻菜单
    menusApi () {
        let _url = rootUrl.menuListHome;
        return axios.get(_url).then((response) => {
            return response.data;
        });
    },
    // 比赛菜单
    matchMenusApi () {
        let _url = rootUrl.menuListMatch;
        console.log('_url', _url);
        // let _url = rootUrl.appInit
        // _url = _url + convenrtUrlFrom(_url);
        return axios.get(_url).then((response) => {
            return response.data;
        });
    },
    // stats菜单
    statsMenusApi () {
        let _url = rootUrl.menuListStats;
        return axios.get(_url).then((response) => {
            return response.data;
        });
    },
    // video菜单
    videoMenusApi () {
        let _url = rootUrl.menuListVideo;
        return axios.get(_url).then((response) => {
            return response.data;
        });
    }
};
// 新闻列表
export const newsApi = {
    getNewsList (_url) {
        return axios.get(_url).then((response) => {
            return response.data;
        });
    }
    // getNewsListNext(nextUrl) {
    //     // 列表下一页
    //     let _url = devUrlConvert(nextUrl);
    //     _url = _url + convenrtUrlFrom(_url);
    //     return axios.get(_url).then((response) => {
    //         return response.data
    //     })
    // },
    // getHaoList() {
    //     let _url = rootUrl.haoFeedUrl;
    //     _url = _url + convenrtUrlFrom(_url);
    //     return axios.get(_url).then((response) => {
    //         return response.data
    //     })
    // },
};
// export function fetchRelative(articleId) {
//     return axios.get('http://localhost:8080/m/v2/article/relate/'+articleId+'?plat=m')
//     .then((response) => {
//       return response.data
//     })
//     .catch(function (error) {
//       return(error);
//     });
// }

// export function fetchComments(articleId) {
//     return axios.get('http://localhost:8080/m/archives/recommend_comments/'+articleId+'?plat=m').then((response) => {
//       return response.data
//     }).catch(function (error) {
//       return(error);
//     });
// }

// 比赛列表
export const matchApi = {
    getMatchList (_url) {
        return axios.get(_url).then((response) => {
            return response.data;
        });
    }
};
// 比赛详情
export const matchDetailApi = {
    // 头部比赛信息
    fetchMatchDetailFormation (matchId) {
        const url = `${apiDomain}/m/data/detail/match/${matchId}?plat=m`;
        return axios.get(url).then(response => response.data);
    },
    // overview
    fetchMatchOverviewFormation (matchId, locale) {
        const url = `${apiDomain}/data/event/match/${matchId}?isJSON=true&language=${locale}`;
        return axios.get(url).then(response => response.data);
    },
    // analysis
    fetchMatchAnalysisFormation (matchId, locale, isJSON) {
        const url = `${apiDomain}/data/new/pre_analysis/${matchId}?isJSON=${isJSON}&language=${locale}`;
        return axios.get(url).then(response => response.data);
    },
    // odds
    fetchMatchOddsEuro (matchId) {
        const url = `${apiDomain}/data/odds_data/summary/euro/${matchId}`;
        return axios.get(url).then(response => response.data);
    },
    fetchMatchOddsAsia (matchId) {
        const url = `${apiDomain}/data/odds_data/summary/asia/${matchId}`;
        return axios.get(url).then(response => response.data);
    },
    fetchMatchOddsOverUnder (matchId) {
        const url = `${apiDomain}/data/odds_data/summary/over_under/${matchId}`;
        return axios.get(url).then(response => response.data);
    }
};
// stats列表
export const statsApi = {
    getStatsList (_url) {
        return axios.get(_url).then((response) => {
            return response.data;
        });
    }
};

// stats列表
export const videoApi = {
    getVideoList (_url) {
        return axios.get(_url).then((response) => {
            return response.data;
        });
    }
};

// tweet文章落地页

export const tweetApi = {
    fetchTweetArticleInfo (_url) {
        console.log('url====', _url)
        return axios.get(_url).then((response) => {
            return response.data;
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/index.js